import { useEffect, useState } from 'react';
import axios from 'axios';
import { apiUrl } from '../config/api';

// Single in-memory cache so multiple components don't each fire a request.
let cached = null;
let inFlight = null;

async function fetchEnvironment() {
  if (cached) return cached;
  if (inFlight) return inFlight;
  inFlight = axios
    .get(apiUrl('/api/env'))
    .then(res => {
      cached = res.data || {};
      return cached;
    })
    .catch(() => {
      // Fail open with permissive defaults so the UI doesn't break in
      // environments that don't expose /api/env (e.g. an older server).
      cached = {
        environment: 'development',
        allowsSelfRegistration: true,
        demo: false,
        resetIntervalHours: 720,
        nextResetAt: null,
      };
      return cached;
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

export function useEnvironment() {
  const [env, setEnv] = useState(cached);
  useEffect(() => {
    let active = true;
    fetchEnvironment().then(data => { if (active) setEnv(data); });
    return () => { active = false; };
  }, []);
  return env;
}

export { fetchEnvironment };
